const isOriginalGameRoute = (
  segments: string[],
  originalGameHandles?: string[],
) =>
  segments.some((segment) => originalGameHandles?.includes(segment) ?? false);

export default isOriginalGameRoute;
